import { useState, useRef, useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { containerClasses, TextField } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { IconButton } from "@material-ui/core";
import { dateTimeFormatter } from '../utils/';
import { CircleAddIcon } from './';
import { connect } from "react-redux";
import DropdownIcon from '../images/icons/dropdown-arrow.svg';
import { Button, Image } from 'react-bootstrap';

function DateTimeInlineEdit(props) {
  const {
    content_group_date,
    type,
    center,
    addButtonClass,
    buttonType,
    asDropdown,
    loading,
    hoverable,
    activeBordered = false,
    containerClassName = '',
  } = props

  const [ isDisabled, setIsDisabled ] = useState(false);
  const [ active, setActive] = useState(false)
  const [ pickerView, setPickerView ] = useState(null);
  const buttonRef = useRef(null);
  const [ contentGroupDate, setContentGroupDate] = useState(content_group_date ? new Date(content_group_date) : null)

  const handleClick = (date) => {
    if(isDisabled) return;

    setActive(!active)

    setTimeout(function() {
      handleOnFocus()
    }, 100)
  }

  const handleOnFocus = () => {}

  const handleOnBlur = () => {
    setActive(false)
    setPickerView(null)
  }

  const handleViewChange = (view) => {
    setPickerView(view)
  }

  const handleChange = (datetime) => {
    setContentGroupDate(datetime)
    setActive(false)

    saveValue(datetime)
  }

  const saveValue = (datetime) => {
    if(isDisabled) return;

    let attributeName = type === 'start_date' ? 'start_date' : 'due_date'
    let params = {}
    params[attributeName] = datetime

    props.handleInlineEdit(handleOnBlur, params, setIsDisabled)
  };

  const defaultRender = () =>{
    return <div 
              className={`d-grid ${center ? "text-center cursor-pointer" : "cursor-pointer"}` }
              style={{ flex: 1 }}
            >
            <Button
                ref={buttonRef}
                variant={'transparent'}
                disabled={loading}
                className={`inline_date text-left`}
                onClick={ () => handleClick() }
                size={'sm'}
              >
                { content_group_date ?
                    dateTimeFormatter(content_group_date)
                  :
                    <div className={addButtonClass}>
                      {
                        `Add ${type === 'start_date' ? 'Start' : 'Due' } Date`
                      }
                    </div>
                }
            </Button>
            
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DateTimePicker open={ active }
                              showToolbar={ false }
                              label="Select date & time"
                              value={ contentGroupDate }
                              onViewChange={ handleViewChange }
                              onClose={ handleOnBlur }
                              onAccept={ handleChange }
                              format="MMM dd, yyyy hh:mm a" 
                              slotProps={{
                                textField: {
                                  InputProps: {},
                                  variant: 'outlined'
                                },
                                popper: { anchorEl: buttonRef.current },
                                actionBar: {
                                  actions: ['clear', 'accept']
                                }
                              }}
                              ampm

              />
            </LocalizationProvider>
          </div>
  }

  const borderClass = () => {
    if (activeBordered) {
      return 'btn-outline-gray'
    } else {
      return ''
    }
  }

  return (
    asDropdown ?

      <div className={`detail ${containerClassName} d-flex flex-column ${hoverable ? 'hoverable' : ''} ${active ? 'active' : 'inactive'} ${ content_group_date ? borderClass() : 'btn-dashed empty' }`} >
        {defaultRender()}
        <Image src={DropdownIcon} height={'8'} width={'8'} className="dropdown-icon"/>
      </div>

    :
     defaultRender()
  );
}


const mapStateToProps = (state) => {
  return {
    loading: state.content_group.content_group_loading,
  };
};

export default connect(mapStateToProps, { })(DateTimeInlineEdit);
